/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface UserStatistics {
  /**
   * Auto Added Creation date
   */
  readonly created_date: string;
  readonly users_trend: string;
  readonly count: number;
  readonly conversion_rate: string;
  readonly users_increase_by_date: { [key: string]: any };
  readonly users_distribution: { [key: string]: any };
}
